/**
 * Returns the last item (tail) in an array
 */
const tail = (arr: any[]) => arr.slice(1);
export default tail;
